import styled from 'styled-components';

export const CheckboxOptionsContainer = styled.div`
  max-height: 408px;
  overflow-y: auto;
  justify-content: space-between;
`;

export const CheckboxOption = styled.div`
  padding: 0.5rem;
`;
